export const ACCESS_TOKEN_STORAGE_KEY = '@studio:user_access_token'
export const REFRESH_TOKEN_STORAGE_KEY = '@studio:user_refresh_token'
